// extracted by mini-css-extract-plugin
export default {"diff_header":"code-conflict-resolved-view-modulediff_header-4PxJ1"};